<template lang="pug">
  .component-card-smart-edit
    smart-edit(:options="options", :value="item", @input="updateFields")
    button.button.expanded(v-on:click="edit") Save and Submit
</template>
<script type="text/babel">
    import SmartEdit from 'components/structure/SmartEdit'
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

    export default {
        name: 'WalletSmartEdit',
        components: {SmartEdit},
        data() {
            return {
                options: {
                    translations: {},
                    types: {
                        'payment_method.name': this.paymentMethodList,
                        'billing_strategy': []
                    },
                    disabled: [
                        'id',
                    ],
                    list: [
                        'id',
                        'uid',
                        'balance',
                        'default',
                        'amounts',
                        'payment_method.data',
                        'payment_method.created',
                        'payment_method.updated',
                        'payment_method.provider',
                        'payment_method.uid',
                        'payment_method.id',

                    ],
                    listMode: 'blacklist',
                }
            }
        },
        created() {
            if (!this.item.payment_method) {
                this.item.payment_method = {id: null, name: null}
            }
            this.options.types.billing_strategy = ['IMMEDIATE', 'END OF MONTH', 'END OF NEXT MONTH']
        },
        methods: {
            updateFields(item) {
                this.item = item
            },
            edit() {

                this.paymentMethods.forEach((item) => {
                    if (item.name === this.item.payment_method.name) {
                        this.item.payment_method.id = item.id
                    }
                })
                KeplerBackofficeSdk.wallets.select(this.item.id).edit(this.item, (data) => {
                    location.reload()
                })
            },
            updatePaymentMethod() {
            }
        },
        props: [
            'item',
            'paymentMethods',
            'paymentMethodList',
        ]
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// WalletEdit.vue?06872869